export default "__VITE_ASSET__C1fK9OSF__"